import { useListProvisionerProducts } from "../api/generated/provisioning-products/provisioning-products";

const EMPTY_PRODUCTS = Object.freeze( [] );

/**
 * The product codes the provisioner may provision, from `GET provisioning/products`, each with the
 * offering name and the names of the product groups it includes.
 *
 * @returns {{products: Object[], isLoading: boolean, isError: boolean}} The products and the query state.
 */
export default function useProvisionerProducts() {
	const { data, isLoading, isError } = useListProvisionerProducts();

	return {
		products: data ?? EMPTY_PRODUCTS,
		isLoading,
		isError,
	};
}
